export default "__VITE_ASSET__RDCJSlTU__"